import BookingCalendar from './booking-calendar.vue'
export default BookingCalendar